import { useRecoilCallback } from 'recoil';
import {
    hoveredAnnotationState,
    removeAnnotation,
    selectedAnnotationState,
    unlessNaming,
} from '~/state/atoms/annotationListAtoms';
import {
    profileHoverState,
    withoutProfileHover,
} from '~/state/atoms/intensityToolAtoms';
import { MEASURE_ANNOTATION_LISTS } from '~/state/atoms/measurementAtoms';

/**
 * Returns a callback that removes one shape of any kind, and the selection,
 * hover and chart pointer naming it; an id no list holds writes nothing.
 */
export function useRemoveAnnotation(): (id: string) => void {
    return useRecoilCallback(
        (callback) => (id: string) => {
            const { snapshot, set } = callback;
            const list = MEASURE_ANNOTATION_LISTS.find((candidate) =>
                snapshot.getLoadable(candidate.ids).getValue().includes(id)
            );
            if (!list) {
                return;
            }
            removeAnnotation(callback, list, id);
            set(selectedAnnotationState, unlessNaming(id));
            set(hoveredAnnotationState, unlessNaming(id));
            set(profileHoverState, withoutProfileHover(id));
        },
        []
    );
}
